import { Link } from 'react-router-dom';

const CTAClosing = () => {
  return (
    <section
      id="contact"
      className="font-heebo relative overflow-hidden py-[clamp(64px,8vw,120px)] px-[clamp(20px,5vw,80px)]"
    >
      <div className="cin-mesh-cta" />
      <div className="mx-auto max-w-[1280px] text-center relative z-10">
        <h2 className="cin-display mb-10 cin-reveal text-[var(--cin-ink)]">נדבר?</h2>
        <p className="text-xl text-[var(--cin-muted)] max-w-xl mx-auto mb-12 cin-reveal cin-reveal-d1">
          תקלה, התלבטות לפני קנייה או רשימת ציוד להצעת מחיר? כתבו בוואטסאפ,
          ובניהו עונה לכם אישית.
        </p>
        <div className="cin-reveal cin-reveal-d2 flex gap-4 justify-center flex-wrap">
          <Link to="/diagnose" className="cin-btn-primary cin-magnetic">
            ייעוץ חינם ←
          </Link>
          <a
            href="https://wa.me/972546672863"
            data-track-from="closing-cta"
            target="_blank"
            rel="noopener noreferrer"
            className="cin-btn-ghost"
            aria-label="פתחו שיחה ב-WhatsApp (נפתח בחלון חדש)"
          >
            כתבו בוואטסאפ
          </a>
        </div>
      </div>
    </section>
  );
};

export default CTAClosing;
